import { ICommonUtilInterface } from "../../domain/common/common-util.interface";
import { Injectable } from "@angular/core";
import { v4 as uuidv4 } from "uuid";

@Injectable()
export class CommonUtils implements ICommonUtilInterface {
  generateGuid(): string {
    return uuidv4();
  }
  generateText(length: number): string {
    return this.generateGuid().replaceAll("-", "").slice(0, length);
  }
  generateInteger(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
